<template lang="pug">
.event-video-des
  .main-container-wide(:class="{ 'has-streamlinks': stream.streamLinks?.length > 1 }")
    h3
      span {{event.title || stream.competitionTitle}}
      span(v-if="stream && stream.name !== event.title") &nbsp;-&nbsp;{{ __(stream.name, 'auto') }}
    .video-desc-title
      .title {{competition.title}}
      .live(v-if="stream && stream.live") {{__('Live', eventNamespace)}}
      .paid(v-if="stream && stream.paid && competition.requirePremium") {{__('Paid Content', eventNamespace)}}
    .description(v-if="desc")
      div(v-html="__(desc, 'auto')" @click="toggleMore($event)")
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { eventNamespace } from '../../js/constants'
import { useMQ } from '../../js/mq'

interface StreamLink {
  name: string
  [key: string]: any
}

const props = withDefaults(defineProps<{
  event?: { 
    title?: string; 
    description?: string; [
    key: string]: any 
  }
  competition: { 
    title: string; 
    requirePremium?: boolean; 
    [key: string]: any 
  }
  stream: { 
    name: string; 
    streamLinks: StreamLink[]; 
    [key: string]: any 
  }
  splitNames: string[]
}>(), {
  event: () => ({}),
})

const expanded = ref(false)
const mq = useMQ()

const activeStreamLink = computed(() => {
  if (props.splitNames?.length) {
    return props.stream?.streamLinks.find(l => l.name === props.splitNames[0])
  }
  
  return undefined
})

const desc = computed(() => {
  const text = props.event?.description || activeStreamLink.value?.description || ''
  
  let length = mq.value === 'mobile' ? 70 : 200

  if (text.length < length) {
    return text
  }

  if (expanded.value) {
    return `${text} <div class="link show-less">Show Less</div>`
  }

  return `${text.substring(0, length)}... <span class="link">Show More</span>`
})

const toggleMore = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (target.classList.contains('link')) {
    expanded.value = !expanded.value
  }
}
</script>
<style lang="scss" scoped>
.event-video-des {
  padding: $size-l 0 $size-l;

  .description {
    margin-top: $size-m;
    font-size: $size-xs;
  }
}

@include not-desktop() {
  .event-video-des {
    background-color: $color-gray-x-light;
  }
}

.main-container-wide.has-streamlinks{
  @include not-desktop {
    margin-top: 75px;
  }
}

.video-desc-title {
  font-size: $size-xs;
  display: flex;
  align-items: center;

  div {
    margin-right: $space-xs;
  }
}

.live {
  background-color: $color-red-dark;
  padding: 0 $space-xxs;
  font-size: 10px;
  font-weight: $weight-bold;
  min-width: 80px;
  text-align: center;
  color: white;
  line-height: 18px;
}

.paid {
  background-color: rgba(91, 189, 21, 0.2);
  padding: 0 $space-xxs;
  font-weight: $weight-bold;
  font-size: 10px;
  color: rgb(73, 151, 17);
  line-height: 18px;
}

</style>
<style lang="scss">
.link.show-less {
  margin-top: $space-xs;
}
</style>
